import { camelCaseToHuman } from '../../../utils/utils';
import { DefaultPrimaryHeader, HeaderBlock, StatusSecondary } from '../activityFeedHeaderShared';

function SecretRemediatedHeader({ entity, linkProps }) {
  return (
    <HeaderBlock
      primary={<DefaultPrimaryHeader label={camelCaseToHuman(entity?.subtype)} activity="remediated" linkProps={linkProps} />}
      secondary={<StatusSecondary previous={entity?.oldStatus} current={entity?.newStatus} />}
    />
  );
}

export default SecretRemediatedHeader;
